import * as React from 'react';

import { NewDataCollectionContentGrouping } from '../../Store/NewDataCollectionParameters';
import { AttributedParagraphSet } from '../../Utils/AttributedParagraph';

import { knownAccountingGroupIds } from '../../Models/AccountingCollectionGroup';
import { PortalTextImportModals } from '../../Models/Api/strongbox.financialportal';

type Props = {
    collectionContentGroups: NewDataCollectionContentGrouping[];
    onContentEnablementChange: (key: string, enabled: boolean) => void;
    additionalMessaging?: AttributedParagraphSet;
    importModalsText?: PortalTextImportModals;
}

export const SelectImportDataItems: React.FC<Props> = (props): React.ReactElement => {

    const {
        additionalMessaging,
        collectionContentGroups,
        onContentEnablementChange,
        importModalsText,
    } = props;

    // Availability note shown italic under each group (which accounting systems / methods support it).
    const appliesToNote = (groupId: string): string => {
        switch (groupId) {
            case knownAccountingGroupIds.financialStatements:
                return importModalsText?.fsGroupAppliesTo || '';
            case knownAccountingGroupIds.transactions:
                return importModalsText?.txnsGroupAppliesTo || '';
            case knownAccountingGroupIds.accountsPayable:
                return importModalsText?.apGroupAppliesTo || '';
            case knownAccountingGroupIds.accountsReceivable:
                return importModalsText?.arGroupAppliesTo || '';
            default:
                return '';
        }
    };

    return (
        <div className={'page-stack'}>
            <p className={'page-body-text'}>{importModalsText?.selectAccountingDataToCollect || ''}</p>
            {collectionContentGroups.map((group) => {
                const appliesToNoteMessage = appliesToNote(group.collectionGroup.id);

                return (
                    <label className={'page-checkbox-row'} key={group.collectionGroup.id}>
                        <input
                            type={'checkbox'}
                            className={'cr-checkbox page-checkbox-row__input'}
                            name={group.collectionGroup.id}
                            id={group.collectionGroup.id}
                            checked={group.selected}
                            disabled={!!group.collectionGroup.readOnly}
                            onChange={(e) => onContentEnablementChange(group.collectionGroup.id, e.currentTarget.checked)}
                        />
                        <div className={'page-stack page-stack--tight'}>
                            <span className={'page-section-label'}>{group.collectionGroup.name}</span>
                            {group.description.map((pg, i) => (
                                <span className={'page-help-text'} key={`${group.collectionGroup.id}-desc-${i}`}>{pg.description}</span>
                            ))}
                            {!!appliesToNoteMessage && (
                                <span className={'page-help-text page-help-text--italic'}>{appliesToNoteMessage}</span>
                            )}
                        </div>
                    </label>
                );
            })}
            {!!additionalMessaging && additionalMessaging.paragraphs.map((p, i) => (
                <span
                    className={'page-help-text'}
                    key={`additional-messaging-content-${i}`}
                    style={!!p.attributes.find(a => a.name === 'bold') ? { fontWeight: 'bold' } : undefined}
                >
                    {p.content}
                </span>
            ))}
        </div>
    );
}
